"use strict";

var Tooltip = require("app/shared/components/Tooltip/tooltip");
var DowngradePrompt = require("app/screens/Pricing/components/DowngradePrompt/downgrade-prompt");
var PromptConfirmButtonGroup = require("app/shared/components/Prompt/prompt-confirm-button-group");

var PLAN_MAX_USERS = 3;

var FreePlanLink = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    subscriptionState: React.PropTypes.string,
    userIsAdmin: React.PropTypes.bool,
    accountUsers: React.PropTypes.number,
    expired: React.PropTypes.bool,
    trial: React.PropTypes.string
  },

  getLinkRule: function() {
    if (this.props.subscriptionState == null) {
      return LinkRules.guestUser();
    } else if(["assinante", "cancelada"].indexOf(this.props.subscriptionState) > -1) {
      return LinkRules.customerUser(this.props.userIsAdmin, this.props.accountUsers,
                                      this.props.expired);
    } else if(this.props.subscriptionState == "trial") {
      return LinkRules.trialUser(this.props.userIsAdmin, this.props.trial, this.props.accountUsers);
    } else if(this.props.subscriptionState == "gratuita") {
      return LinkRules.freeUser(this.props.trial);
    }
  },
  render: function() {
    var buttonRule = this.getLinkRule();
    return (
      <div className="mt-50">
        <LinkFactory buttonRule={buttonRule} accountUsers={this.props.accountUsers} />
      </div>
    );
  }
});

var LinkRules = {
  guestUser: function guestUser() {
    return "guest-start-freePlan";
  },
  customerUser: function customerUser(userIsAdmin, accountUsers, expired) {
    if(!userIsAdmin){
      return "disabled-admin-only";
    } else if (accountUsers > PLAN_MAX_USERS) {
      return "disabled-user-overload";
    } else {
      return "downgrade";
    }
  },
  trialUser: function trialUser(userIsAdmin, trial, accountUsers) {
    if(!userIsAdmin){
      return "disabled-admin-only";
    } else if (["realizada", "ativa"].indexOf(trial) > -1 && accountUsers > PLAN_MAX_USERS) {
      return "disabled-user-overload";
    } else {
      return "downgrade";
    }
  },
  freeUser: function freeUser(trial) {
    return "current-plan";
  }
};

var LinkFactory = React.createClass({
  mixins: [ReactIntl.IntlMixin],

  disabledLink: function(message) {
    return(
      <span>
        Você também pode
        <Tooltip bottom title={message}>
          <a className="ml-5 disabled-link c-disabled">reduzir para o Plano Gratuito</a>         
        </Tooltip>  
        <span> ou</span>
        <br />      
        <a className="ml-5 downgrade-link" target="_blank" href="https://parceiros.agendor.com.br/indicacao-cliente">recomendar o Agendor para ganhar descontos! &#x1F911;</a>        
      </span>
    )
  },

  render: function() {
    var buttonRule = this.props.buttonRule;
    if(buttonRule == "guest-start-freePlan") {
      var buttonText = this.getIntlMessage("pricing.buttons.start_free");
      return (
        <span>
          Ou,
          <a className="ml-5" href="/cadastro/?pid=1" name="_top">comece a usar o Agendor Gratuito</a>
        </span>
      );
    } else if(buttonRule == "disabled-admin-only"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan");
      var message = this.getIntlMessage("pricing.warning.admin_only");
      return (
        <div>
          {this.disabledLink(message)}
        </div>
      );
    } else if(buttonRule == "disabled-user-overload"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan");
      var message = this.getIntlMessage("pricing.warning.user_overflow");
      var usersVariation = this.props.accountUsers - PLAN_MAX_USERS;
      var formattedMessage = this.formatMessage(message, {users: usersVariation});
      return (
        <div>
          {this.disabledLink(formattedMessage)}
        </div>
      );
    } else if(buttonRule == "disabled-wait-expire"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan");
      var message = this.getIntlMessage("pricing.warning.wait_expire");
      return (
        <div>
          {this.disabledLink(message)}
        </div>
      );
    } else if(buttonRule == "current-plan"){
      var text = this.getIntlMessage("pricing.buttons.current_plan");
      return (
        <div>
          {this.disabledLink(text)}
        </div>
      );
    } else if(buttonRule == "downgrade"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan");
      var accountLosses = {
        limitsExceeded: true,
        customCategories: true,
        customDealStages: true,
        privacy: true,
        googleCalendarIntegration: true
      };
      return (
        <PromptConfirmButtonGroup>
          <DowngradePrompt redirectUrl={"/src/php/sistema/http/obj/Cliente/alterar-plano.php?pid=1"}
                            accountLosses={accountLosses} />
          <span>
            Você também pode
            <a className="ml-5 downgrade-link" href="javascript:void();" onclick={`javascript:{this.props.onClick}`}>reduzir para o Plano Gratuito</a>
            <span> ou</span>
            <br />
            <a className="ml-5" target="_blank" href="https://parceiros.agendor.com.br/indicacao-cliente">recomendar o Agendor para ganhar descontos! &#x1F911;</a>       
          </span>                    
        </PromptConfirmButtonGroup>
      );
    }
  }
});

module.exports = FreePlanLink;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/free-plan-link.jsx